'use client';

import NextError from 'next/error';
import posthog from 'posthog-js';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('CRITICAL GLOBAL ERROR', error);
    if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <h2>
          Something went wrong! Please contact support at support@jellypod.ai
        </h2>
        <NextError statusCode={0} />
        <button onClick={() => reset()} type="button">
          Try again
        </button>
      </body>
    </html>
  );
}
